export default __webpack_public_path__ + "static/the_first_tape-56fd1155bfdebd8655375800a13bc5f8.mp3";